const textProps = {
  title: "Sign up",
  button: {
    fullWidth: true,
    color: "dark",
    children: "Create account",
  },
  signIn: {
    href: "#/login",
  },
  checkbox: {
    label: "I agree with the Privacy Policy",
  },
  inputs: [
    {
      label: "Name",
      input: {
        type: "text",
        placeholder: "Name",
      },
    },
    {
      label: "Email",
      input: {
        type: "email",
        placeholder: "Email",
      },
    },
    {
      label: "Password",
      input: {
        type: "password",
        placeholder: "Password",
      },
    },
    {
      label: "Confirm Password",
      input: {
        type: "password",
        placeholder: "confirm Password",
      },
    },
  ],
};
export default textProps;
